import { type CrossSellProduct } from '@redteclab/api/clients/retail-media-xsell-service'

import { apmCaptureError } from '../../apm'
import {
  TENANT,
  type TenantLanguage,
  tenantLanguagesConfig,
  tenantToLocaleRegionMap,
} from '../../tenant'

export const crossSellAccessorGetLocalizedProductName = ({
  language,
  product,
  tenant,
}: {
  language: TenantLanguage
  product: CrossSellProduct
  tenant: TENANT
}): string => {
  if ('name' in product) {
    return product.name
  }

  /**
   * Temporary solution to get the localized product name for multilingual tenant type safe.
   * Will be refactored later.
   */
  if (tenant === TENANT.BE && 'name_fr_BE' in product) {
    const lang = tenantLanguagesConfig[TENANT.BE].languages.find(
      (item) => item === language,
    )

    if (lang) {
      return product[`name_${lang}_${tenantToLocaleRegionMap[tenant]}`]
    }
  }

  if (tenant === TENANT.CH && 'name_fr_CH' in product) {
    const lang = tenantLanguagesConfig[TENANT.CH].languages.find(
      (item) => item === language,
    )

    if (lang) {
      return product[`name_${lang}_${tenantToLocaleRegionMap[tenant]}`]
    }
  }

  apmCaptureError(
    new Error(
      `CROSS_SELL: product name not found for "${product.id}" for ${tenant} ${language}`,
    ),
  )

  return ''
}
